import { css } from "styled-components";
import { NAMESPACE } from "../constants";
import { typeStyleProperties } from "../typography";
const calculateParagraphSpacing = (name) => {
    const typeStyleConfig = typeStyleProperties[name];
    if (typeStyleConfig === null || typeStyleConfig === undefined) {
        return;
    }
    const { fontSize, lineHeight } = typeStyleConfig;
    const lineLeading = fontSize * lineHeight - fontSize;
    const margin = 1.5 * lineLeading;
    return margin;
};
const marginStrategyCss = {
    adjacent: (paragraphSpacing) => css `
    & + & {
      margin-top: ${paragraphSpacing}px;
    }
  `,
    bottom: (paragraphSpacing) => css `
    margin-bottom: ${paragraphSpacing}px;
  `,
    collapse: (paragraphSpacing) => css `
    margin: ${paragraphSpacing}px 0;
  `,
    "not-last": (paragraphSpacing) => css `
    &:not(:last-child) {
      margin-bottom: ${paragraphSpacing}px;
    }
  `
};
export const typeStyle = (name, options = { marginStrategy: "none" }) => ({ theme }) => {
    const paragraphSpacing = calculateParagraphSpacing(name);
    const marginCss = paragraphSpacing && options.marginStrategy !== "none"
        ? marginStrategyCss[options.marginStrategy](Number(paragraphSpacing.toFixed(2)))
        : "";
    const typeStyleCss = theme[NAMESPACE].typography.typeStyles[name];
    if (!typeStyleCss) {
        throw new Error(`No typeStyle found in theme for "${name}"`);
    }
    return css `
      ${typeStyleCss}
      ${marginCss}
    `;
};
